<template>
  <div class="detail-tab">
    <div class="dt-container">
      <button
        type="button"
        :class="[activeTab === 'overview' ? 'active' : '', 'tab']"
        @click="changeTab('overview')"
      >
        Overview
      </button>
      <button
        v-if="isSmacAdmin"
        type="button"
        :class="[activeTab === 'notification' ? 'active' : '', 'tab']"
        @click="changeTab('notification')"
      >
        Notification Preferences
      </button>
      <button
        v-if="isMonitoredMember"
        type="button"
        :class="[activeTab === 'cycle' ? 'active' : '', 'tab']"
        @click="changeTab('cycle')"
      >
        Cycle Details
      </button>
      <button
        v-if="isMonitoredMember"
        type="button"
        :class="[activeTab === 'deltaT' ? 'active' : '', 'tab']"
        @click="changeTab('deltaT')"
      >
        Interval Readings
      </button>
      <button
        v-if="isMonitoredMember"
        type="button"
        :class="[activeTab === 'runtime' ? 'active' : '', 'tab']"
        @click="changeTab('runtime')"
      >
        Daily Trends
      </button>
      <button
        v-if="isMonitoredMember"
        type="button"
        :class="[activeTab === 'alerts' ? 'active' : '', 'tab']"
        @click="changeTab('alerts')"
      >
        Alerts
      </button>
      <button
        type="button"
        :class="[activeTab === 'activity' ? 'active' : '', 'tab']"
        @click="changeTab('activity')"
      >
        Activity
      </button>
      <button
        type="button"
        :class="[activeTab === 'orders' ? 'active' : '', 'tab']"
        @click="changeTab('orders')"
      >
        Orders
      </button>
      <button
        type="button"
        :class="[activeTab === 'address' ? 'active' : '', 'tab']"
        @click="changeTab('address')"
      >
        Addresses
      </button>
      <button
        v-if="isMonitoredMember"
        type="button"
        :class="[activeTab === 'performanceSummary' ? 'active' : '', 'tab']"
        @click="changeTab('performanceSummary')"
      >
        Performance Summary
      </button>
    </div>
  </div>
</template>

<script>
import customerDetailMixin from '@shared/mixins/customerDetailMixin';
import { mapGetters } from 'vuex';

export default {
  name: 'DetailTab',
  mixins: [customerDetailMixin],
  computed: {
    ...mapGetters([
      'isSmacAdmin',
    ]),
    isMonitoredMember() {
      if (!this.customer) {
        return false;
      }
      if (!this.customer.membershipType) {
        return false;
      }
      return (
        this.customer.membershipType.toLowerCase() === 'paid' ||
        this.customer.membershipType.toLowerCase() === 'premium' ||
        this.customer.membershipType.toLowerCase() === 'monitored'
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.detail-tab {
  display: flex;
  background-color: $N90;
  padding-left: 100px;
  padding-right: 100px;
  width: 100%;
  justify-content: center;
  .dt-container {
    display: flex;
    max-width: 1705px;
    width: 100%;
  }
  .tab {
    display: flex;
    height: 42px;
    padding: 0 20px;
    align-items: center;
    justify-content: center;
    color: $WHITE;
    font-size: 14.42px;
    font-weight: 500;
    cursor: pointer;
    &:hover {
      background-color: $N80;
    }
    &.active {
      background-color: $N80;
      color: $SUNSET100;
      border-bottom: 2px solid $SUNSET100;
    }
  }
}
</style>
